import { render } from "./BaseFormItem.vue?vue&type=template&id=2247bee7"
import script from "./BaseFormItem.vue?vue&type=script&lang=js"
export * from "./BaseFormItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__